module.exports = __webpack_public_path__ + "assets/images/src/assets/images/PizzaHutBG.jpg";